// fallow-ignore-file unused-file
import * as Sentry from "@sentry/gatsby";

Sentry.init({
  dsn: process.env.GATSBY_SENTRY_DSN,
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/gatsby/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  // Enable tracing for performance monitoring
  tracesSampleRate: 0,
  // Only send errors in production
  enabled: process.env.NODE_ENV === 'production',
  // Release version
  release: process.env.SENTRY_RELEASE || 'development',
  // Environment
  environment: process.env.NODE_ENV || 'development',
});